module.exports = __webpack_public_path__ + "img/FRAX.2ccf8e10.svg";